module.exports = __webpack_public_path__ + "static/media/buffet3.03fc2df2.jpg";